export enum BackgroundType {
  Image = 'image',
  Video = 'video',
  ImageSlider = 'imageSlider',
}

export enum ContentType {
  Article = 'article',
  Featured = 'featured',
}

export type Theme = 'dark' | 'light' | 'default';

export interface FeatureCardProps {
  type: 'article' | 'feature'
  title: string | JSX.Element;
  description: string;
  callToAction?: string;
  imageUrl?: string;
  linkUrl?: string;
  theme?: Theme;
  overlayStyle?: string;
  cardBgColor?: string;
  descriptionStyle?: string
}
export interface ArticleCardProps {
  type: 'article' | 'feature'
  title: string | JSX.Element;
  description: string;
  imageUrl?: string;
  linkUrl?: string;
  callToAction: string;
  overlayStyle?: string;
    descriptionStyle?: string
  theme?: Theme;
  background?: boolean;
  cardBgColor?: string;
}

export interface BackgroundProps {
  backgroundType: BackgroundType;
  src: string;
  children?: React.ReactNode;
}

export type ArticleWithBg = ArticleCardProps & BackgroundProps;
export type FeatureWithBg = FeatureCardProps & BackgroundProps;
